<div class="filter-options">
  <mat-form-field *ngIf="filterFormControl" appearance="fill">
    <input
      class="filter"
      #filter
      matInput
      placeholder="Start typing to search"
      data-test="search-input"
      [formControl]="filterFormControl"
    />
  </mat-form-field>
</div>
